export enum AgeGroupEnum {
	underForty = 'under 40',
	aboveForty = '40 or above',
}
